import { flatMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { concat, EMPTY } from 'rxjs';
import { setEnvs, RESET_MARKET_ENVS } from '@clearscore/helpers.envs';
import sessionTypes from '@clearscore/constants.session-action-types';

function resetSession() {
    return function logoutAction() {
        setEnvs(RESET_MARKET_ENVS);
        if (window.analytics && window.analytics.reset) window.analytics.reset();
        if (window._detector && window._detector.invalidateSession) window._detector.invalidateSession();
        return concat(EMPTY);
    };
}

export function epic(action$) {
    return action$.pipe(ofType(sessionTypes.LOGOUT_SUBMIT), flatMap(resetSession()));
}

export default epic;
